import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component6cards from '../components/component6cards'
import Component4cards from '../components/component4cards'
import Componentpartners from '../components/componentpartners'
import FooterMain from '../components/footer-main'
import './main.css'

const __staticProp0 = {
  url: '/robotic-welding',
  newTab: false,
}

const __staticProp1 = {
  url: '/palletizing',
  newTab: false,
}

const __staticProp2 = {
  url: '/cnc',
  newTab: false,
}

const __staticProp3 = {
  url: '/repair',
  newTab: false,
}

const __staticProp4 = {
  url: '/exhibition-robotic',
  newTab: false,
}

const __staticProp5 = {
  url: '/education-cells',
  newTab: false,
}

const Main = (props) => {
  return (
    <div className="main-container">
      <Helmet>
        <title>
          Arcobo – Роботизация, сварочные роботы и 3D-печать металлом
        </title>
        <meta
          name="description"
          content="Arcobo разрабатывает решения для роботизации: автоматизация сварки, контроль ручной сварки, WAAM 3D-печать металлом и шоу-роботы."
        />
        <meta
          property="og:title"
          content="Arcobo – Роботизация, сварочные роботы и 3D-печать металлом"
        />
        <meta
          property="og:description"
          content="Arcobo разрабатывает решения для роботизации: автоматизация сварки, контроль ручной сварки, WAAM 3D-печать металлом и шоу-роботы."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Arcobo – Роботизация, сварочные роботы и 3D-печать металлом"
        />
        <meta
          name="twitter:description"
          content="Arcobo разрабатывает решения для роботизации: автоматизация сварки, контроль ручной сварки, WAAM 3D-печать металлом и шоу-роботы."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"Organization","name":"Arcobo – Роботизация, сварочные роботы и 3D-печать металлом","url":"https://arcobo.tech","logo":"https://arcobo.tech/og_image.png"}',
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"WebSite","name":"Arcobo – Роботизация, сварочные роботы и 3D-печать металлом","url":"https://arcobo.tech","description":"Arcobo разрабатывает решения для роботизации: автоматизация сварки, контроль ручной сварки, WAAM 3D-печать металлом и шоу-роботы."}',
          }}
        />
      </Helmet>
      <HeaderMain></HeaderMain>
      <hr className="main-separator1"></hr>
      <Componenttextimage
        image1Src="/0_Main_page/main_00-1500w.webp"
        image1Alt="Промышленная роботизация Arcobo"
        rootClassName="componenttextimageroot-class-name"
        textComponent={
          <Fragment>
            <span className="main-text10">
              Внедряем роботизированные комплексы для сварки, паллетирования,
              обслуживания станков, контроля качества и других производственных
              операций
            </span>
          </Fragment>
        }
        componentTitle="Промышленная роботизация для предприятий Казахстана и Центральной Азии"
      ></Componenttextimage>
      <Component6cards
        feature1Url={__staticProp0}
        feature2Url={__staticProp1}
        feature3Url={__staticProp2}
        feature4Url={__staticProp3}
        feature5Url={__staticProp4}
        feature6Url={__staticProp5}
        componentText="Проектирование, локальное производство, программирование, обучение и сервис робототехнических комплексов"
        feature1Title="Роботизированная сварка"
        feature2Title="Паллетирование и упаковка"
        feature3Title="Обслуживание станков ЧПУ"
        feature4Title="Наплавка и восстановление деталей"
        feature5Title="Интерактивные шоу-ячейки"
        feature6Title="Учебные робототехнические комплексы"
        rootClassName="component6cardsroot-class-name1"
        componentTitle="Решения"
        feature1ImageSrc="/0_Main_page/Solution/welding_11.png-1500w.webp"
        feature1ImageAlt="Роботизированная сварка"
        feature2ImageSrc="/0_Main_page/Solution/palletizing_12-300h.webp"
        feature2ImageAlt="Паллетирование и упаковка"
        feature3ImageSrc="/0_Main_page/Solution/cnc_13-300h.webp"
        feature3ImageAlt="Обслуживание станков ЧПУ"
        feature4ImageSrc="/0_Main_page/Solution/cladding_21-1500w.webp"
        feature4ImageAlt="Специальные робототехнические комплексы"
        feature5ImageSrc="/0_Main_page/Solution/interactive_22-300h.webp"
        feature5ImageAlt="Выставочные и интерактивные комплексы"
        feature6ImageSrc="/0_Main_page/Solution/training_23-300h.webp"
        feature6ImageAlt="Учебные робототехнические комплексы"
        feature1Description={
          <Fragment>
            <span className="main-thq-feature1-description-elm1 thq-body-small">
              <span>
                Снижение зависимости от дефицита сварщиков и повышение
                производительности производства. Инжиниринг, запуск и
                сопровождение под ключ.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="main-thq-feature1-description-elm2 thq-body-small">
              <span>
                Роботизированная укладка продукции и автоматизация упаковочных
                процессов. Снижение нагрузки на персонал и работа в режиме 24/7.
                Интеграция с конвейерами и складской инфраструктурой.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="main-text15">
              <span>
                Автоматическая загрузка и выгрузка деталей на токарных и
                фрезерных станках. Увеличение коэффициента загрузки оборудования
                и сокращение простоев.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature4Description={
          <Fragment>
            <span className="main-text18">
              <span>
                Восстановление изношенных поверхностей и нанесение
                функциональных покрытий. Продление срока службы узлов и снижение
                затрат на закупку новых деталей.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature5Description={
          <Fragment>
            <span className="main-text21">
              <span>
                Роботизированные комплексы для выставок, шоурумов и
                демонстрационных площадок для привлечения внимания аудитории.
                Разработка уникальных проектов под задачи заказчика.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature6Description={
          <Fragment>
            <span className="main-text24">
              Современные лаборатории для вузов, колледжей и корпоративных
              учебных центров для подготовки инженеров и операторов. Полное
              оснащение, методическая поддержка и запуск под ключ.
            </span>
          </Fragment>
        }
      ></Component6cards>
      <Component4cards
        title1="более 9 лет"
        title2="Первый в Центральной Азии"
        title3="Kawasaki Robotics"
        title4="База в Алматы"
        heading1="Что отличает Arcobo?"
        imageSrc="/0_Main_page/icons/experience_square-200h.webp"
        imageAlt="Опыт Arcobo"
        imageSrc1="/0_Main_page/icons/first_printer-200w.webp"
        imageSrc2="/0_Main_page/icons/kawasaki_partner-200w.webp"
        imageSrc3="/0_Main_page/icons/kazakhstan-200h.webp"
        description1="опыта в промышленной роботизации и автоматизации производства"
        description2="индустриальный WAAM-принтер для печати металлических деталей"
        description3="с 2026 года - официальный партнер\xA0в Центральной Азии"
        description4="производственная площадка для изготвления компонетов"
        rootClassName="component4cardsroot-class-name1"
      ></Component4cards>
      <Componentpartners rootClassName="componentpartnersroot-class-name"></Componentpartners>
      <hr className="main-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name"></FooterMain>
    </div>
  )
}

export default Main
